"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupEventGroupsBySport = void 0;
const groupAllEventsByGroupId_1 = require("./groupAllEventsByGroupId");
/**
 * !!! Function does NOT guarantee order of events
 *
 * Group EventGroups by sport
 * @param events Event[]
 * @returns SportTournamentsGroup[]
 */
const groupEventGroupsBySport = (events) => {
    const groupedEvents = (0, groupAllEventsByGroupId_1.groupAllEventsByGroupId)(events);
    if (groupedEvents.length === 0)
        return [];
    const sportIndexes = [];
    const groupBySport = {};
    for (let i = 0; i < groupedEvents.length; i += 1) {
        const eventGroup = groupedEvents[i];
        if (groupBySport[eventGroup.sportId] === undefined) {
            groupBySport[eventGroup.sportId] = [];
            sportIndexes.push(eventGroup.sportId);
        }
        groupBySport[eventGroup.sportId].push(eventGroup);
    }
    return sportIndexes.map((sportId) => ({
        sportId,
        id: sportId,
        eventGroups: groupBySport[sportId],
    }));
};
exports.groupEventGroupsBySport = groupEventGroupsBySport;
//# sourceMappingURL=groupEventGroupsBySport.js.map